export const WIDGETS_API_VERSION = "1";
